<router-outlet>
    <ngx-spinner [zIndex]="9999999999999"></ngx-spinner>
 
    <!-- Confirm Dialog with Modern Styling -->
    <p-confirmDialog #cd maskStyleClass="confirm-top-zindex" [baseZIndex]="999999999999"
        icon="pi pi-exclamation-triangle" [transitionOptions]="'0ms'">
        <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
            <div class="bg-card border border-border rounded-lg shadow-lg overflow-hidden"
                style="min-width: 400px; max-width: 500px;">
                <!-- Header -->
                <div class="px-6 py-4 border-b border-border bg-muted/30">
                    <div class="flex items-center gap-3">
                        <div
                            class="flex items-center justify-center w-10 h-10 bg-orange-100 rounded-full flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                class="w-5 h-5 text-orange-600">
                                <path fill-rule="evenodd"
                                    d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                        <h3 class="text-foreground font-semibold" style="font-size: var(--text-lg); margin: 0;">
                            {{ message.header ? message.header : ('_Thông báo_' | translate) }}
                        </h3>
                    </div>
                </div>

                <!-- Content -->
                <div class="px-6 py-5">
                    <p class="text-foreground" style="font-size: var(--text-sm); margin: 0; line-height: 1.6;">
                        {{ message.message }}
                    </p>
                </div>

                <!-- Footer with Actions -->
                <div class="px-6 py-4 bg-muted/20 border-t border-border flex items-center justify-end gap-2">
                    <button type="button"
                        class="inline-flex items-center justify-center h-9 px-4 border border-border bg-card text-foreground hover:bg-muted transition-colors"
                        style="border-radius: var(--radius); font-size: var(--text-sm); font-weight: var(--font-weight-medium);"
                        (click)="onReject()">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"
                            class="w-4 h-4 mr-2">
                            <path
                                d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
                        </svg>
                        {{ '_Hủy bỏ_' | translate }}
                    </button>
                    <button type="button"
                        class="inline-flex items-center justify-center h-9 px-4 bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
                        style="border-radius: var(--radius); font-size: var(--text-sm); font-weight: var(--font-weight-medium);"
                        (click)="onAccept()">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"
                            class="w-4 h-4 mr-2">
                            <path fill-rule="evenodd"
                                d="M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353 4.493-6.74a.75.75 0 0 1 1.04-.207Z"
                                clip-rule="evenodd" />
                        </svg>
                        {{ '_Xác nhận_' | translate }}
                    </button>
                </div>
            </div>
        </ng-template>
    </p-confirmDialog>

    <!-- Toast Notifications -->
    <p-toast position="top-right" [baseZIndex]="9999999999999" [autoZIndex]="false"></p-toast>

</router-outlet>

<p-drawer [(visible)]="visible" header="Drawer">
</p-drawer>